import PropTypes from 'prop-types';
// @mui
import { Box, Card, Link, Typography, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
// components
import Label from '../components/label';
import { ColorPreview } from '../components/color-utils';

// ----------------------------------------------------------------------

const StyledProductImg = styled('img')({
  top: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',
});

// ----------------------------------------------------------------------

export default function ClanFoto({ product }) {
  const { ime, prezime, maticnibrojlovca, adresa, telefon, datumpolaganja, vrstaclanstva, lovackilist, photo } = product;
  console.log(product);
  console.log(product.ime);
  console.log(adresa);
  const lovackodrustvo = product.huntingclub.naziv;

  return (
    <Card width = "100px">
      <Box sx={{ pt: '100%', position: 'relative' }}>
        <StyledProductImg alt={ime} src={photo} />
      </Box>

      <Stack spacing={2} sx={{ p: 3 }}>
        <Link color="inherit" underline="hover">
          <Typography align="center" variant="subtitle3" noWrap>
            {ime} {prezime}
          </Typography>
        </Link>

        <Stack direction="column" alignItems="left" justifyContent="space-between">
		  <Typography variant="subtitle2" noWrap>
            Matični broj: {maticnibrojlovca}
          </Typography>
		  
		  <Typography variant="subtitle2" noWrap>
            Adresa: {adresa}
          </Typography>
		  
		  <Typography variant="subtitle2" noWrap>
            Telefon: {telefon}
          </Typography>
		  
		  <Typography variant="subtitle2" noWrap>
            Lovačko društvo: {lovackodrustvo}
          </Typography>
		  
		  <Typography variant="subtitle2" noWrap>
            Datum polaganja lovačkog ispita: {datumpolaganja}
          </Typography>
		  
		  <Typography variant="subtitle2" noWrap>
            Vrsta članstva: {vrstaclanstva}
          </Typography>
		  
		  <Typography variant="subtitle2" noWrap>
            Lovački list: {lovackilist}
          </Typography>
        </Stack>
      </Stack>
    </Card>
  );
}
